import { useContext } from 'react';

import { GoalFormContext } from './goal-form-context';

export const useOpenEditGoalDialog = () => {
  const { onEditGoal } = useContext(GoalFormContext);

  return onEditGoal;
};
